import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Answer } from 'typings/filters'

type AppliedFilters = Record<number, Answer[]>

const initialState: AppliedFilters = {}

type ValueCacheRecord = {
  variable_id: number
  values: Answer[]
}

const valuesSlice = createSlice({
  name: 'values',
  initialState,
  reducers: {
    setFilterValues(state, action: PayloadAction<ValueCacheRecord>) {
      const { variable_id, values } = action.payload

      state[variable_id] = values
    },
  },
})

export const { setFilterValues } = valuesSlice.actions

export default valuesSlice.reducer
